import { AppState } from '@app/ngrx/app-state/app-state';
import { createSelector } from '@ngrx/store';

export const getTopTeamState = (state: AppState) => state.topTeam;

export const getTopTeamCollection = createSelector(
  getTopTeamState,
  (state) => state.topTeam
);

export const getTopTeamLoading = createSelector(
  getTopTeamState,
  (state) => state.loading
);

export const getTopTeamLoaded = createSelector(
  getTopTeamState,
  (state) => state.loaded
);

export const getTopTeamTotal = createSelector(
    getTopTeamState,
    (state) => state.totalCount
);
